export const polarPoint = (cx: number, cy: number, radius: number, angle: number): [number, number] => {
  const radians = (angle * Math.PI) / 180
  return [cx + radius * Math.sin(radians), cy - radius * Math.cos(radians)]
}

export const arcPath = (cx: number, cy: number, radius: number, start_angle: number, end_angle: number): string => {
  const [start_x, start_y] = polarPoint(cx, cy, radius, start_angle)
  const [end_x, end_y] = polarPoint(cx, cy, radius, end_angle)
  const large_arc = end_angle - start_angle > 180 ? 1 : 0
  return `M ${start_x} ${start_y} A ${radius} ${radius} 0 ${large_arc} 1 ${end_x} ${end_y}`
}
